<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <strong>* Set up administrator access IPs, api IPs, etc. that are important or need to be handled with exceptions.</strong>
        <hr>
        <strong>* Example : In one row, enter one IP</strong>
        <br>
        <br>
        <span>111.222.111.222</span><br><span>111.222.111.222</span>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col :sm="is_setup ? '12' : '6'">
        <strong>Allow IP</strong> : <span>Write down the IP to allow</span>(* All bypass)
        <b-button class="pull-right" size="sm" variant="outline-info" @click="explain_ip_allow = true"><i class="fa fa-question"></i></b-button>
        <hr>
        <b-form-group>
          <b-form-textarea @update="allow_ip($event, 'allow_ip')" @change="allow_ip" v-model="model.allow_ip" :row="10" :max-rows="50"></b-form-textarea>
        </b-form-group>
      </b-col>
      <!-- is_setup 사용, 아직 블럭할 ip 를 구분할 수 없을 것임 -->
      <b-col sm="6" v-if="!is_setup">
        <strong>
          <!-- <b-badge v-if="server.mode == 'DetectionOnly' || server.mode == 1" variant="warning">Detection</b-badge>
          <b-badge v-else-if="server.mode == 'On' || server.mode == 2" variant="danger">Block</b-badge>
          <span v-else>-</span> -->
          Block IP : <span class="text-danger">Blocked regardless of firewall mode</span>
        </strong>
        <b-button class="pull-right" size="sm" variant="outline-info" @click="explain_ip_block_or_detect = true"><i class="fa fa-question"></i></b-button>
        <hr>
        <b-form-group>
          <b-form-textarea @update="block_ip($event, 'block_ip')" @change="block_ip" v-model="model.block_ip" :row="10" :max-rows="50"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="Allow IP"  class="modal-info" v-model="explain_ip_allow" ok-variant="success" header-bg-variant="success">
      <p>You can set IP addresses or ranges that pass through without analysis.</p>
      <p>ex ) 211.222.235.14</p>
    </b-modal>
    <b-modal title="IP Address Manage"  class="modal-info" v-model="explain_ip_block_or_detect" ok-variant="success" header-bg-variant="warning">
      <p>You can set IP addresses or ranges that block without analysis.</p>
      <p>ex ) 211.222.235.14</p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
